import { render, staticRenderFns } from "./BiReportDesigner.vue?vue&type=template&id=72c0b22c&scoped=true"
import script from "./BiReportDesigner.vue?vue&type=script&lang=js"
export * from "./BiReportDesigner.vue?vue&type=script&lang=js"
import style0 from "./BiReportDesigner.vue?vue&type=style&index=0&id=72c0b22c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c0b22c",
  null
  
)

export default component.exports